export * from './CopyIcon';
export * from './CopyIcon16Light';
export * from './CopyIcon16Regular';
export * from './CopyIcon16Solid';
export * from './CopyIcon20Light';
export * from './CopyIcon20Regular';
export * from './CopyIcon20Solid';
export * from './CopyIcon24Regular';
export * from './CopyIcon24Solid';
export * from './CopyIcon32Regular';
export * from './CopyIcon64Regular';
